import { NgModule }      from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule }  from '@angular/common';
import { Routes, RouterModule }  from '@angular/router';


import { PagesLockscreen } from './lockscreen.page';
import { PagesLoginAlpha } from './login-alpha.page';

import { PagesPage404 } from './page-404.page';
import { PagesPage500 } from './page-500.page';

import { PagesRegister } from './register.page';

export const routes: Routes = [
  { path: 'pages/login', component: PagesLoginAlpha },
  { path: 'pages/lockscreen', component: PagesLockscreen },
  { path: 'pages/page-404', component: PagesPage404 },
  { path: 'pages/page-500', component: PagesPage500 },
  { path: 'pages/register', component: PagesRegister }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    PagesLockscreen,
    PagesLoginAlpha,
    PagesPage404,
    PagesPage500,
    PagesRegister
  ]

})
export class PagesModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/pages/pages.module.ts